import { useCallback, useMemo } from "react";
import { get, has } from "lodash";

import { useFlags } from "components/FeatureFlag/useFlags";

function useAddUserOnboardingFF(id = "add-user-during-onboarding") {
  const { loadingConfig, flags } = useFlags();

  return useMemo(() => {
    return {
      loadingConfig: loadingConfig,
      addUserOnboardingFF:
        !loadingConfig && has(flags, id) ? get(flags, id) : {},
    };
  }, [id, loadingConfig, flags]);
}

function useInitActiveStep(advisor) {
  const { loadingConfig, addUserOnboardingFF } = useAddUserOnboardingFF();

  const getActiveStep = useCallback(() => {
    const isProfileReady = () => {
      return advisor.firstName && advisor.lastName && advisor.phoneNumber;
    };
    const isSubscriptionReady = () => {
      const advisorPractices = advisor.practices || [];
      return (
        advisor.subscriptionConfirmation === "OK" ||
        (advisorPractices.length > 0 && advisorPractices[0].accountId)
      );
    };
    const isConnectCrmStepCompleted = () => {
      return advisor?.hubs?.[0]?.clientPool?.type;
    };

    if (!isProfileReady()) return { id: "profile", idx: 0 };
    if (!isSubscriptionReady()) return { id: "subscription", idx: 1 };
    if (
      !isConnectCrmStepCompleted() ||
      (!advisor?.setupComplete && !addUserOnboardingFF?.enable)
    )
      return { id: "crm", idx: 2 };
    if (!advisor?.setupComplete && addUserOnboardingFF?.enable) {
      return { id: "add-user", idx: 3 };
    }

    return {};
  }, [advisor, addUserOnboardingFF]);

  const withAddUserStep = useMemo(() => {
    return !addUserOnboardingFF?.enable
      ? []
      : [addUserOnboardingFF?.stepTitle || "Add User"];
  }, [addUserOnboardingFF]);

  return {
    loadingConfig: loadingConfig,
    active: getActiveStep(),
    steps: ["Profile", "Subscription", "CRM Integration"].concat(
      withAddUserStep
    ),
  };
}

export default useInitActiveStep;
